import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faPrescription } from '@fortawesome/pro-regular-svg-icons/faPrescription'
import { faShieldVirus } from '@fortawesome/pro-regular-svg-icons/faShieldVirus'
import { faVial } from '@fortawesome/pro-regular-svg-icons/faVial'
import { faVirusSlash } from '@fortawesome/pro-regular-svg-icons/faVirusSlash'

const propertyMap: Record<string, IconDefinition> = {
  Antiangiogenic: faVial,
  Antineoplastic: faVirusSlash,
  Immunomodulatory: faShieldVirus,
}

export const getIconByPropertyLabel = (label: string): IconDefinition => {
  return label && propertyMap[label]
    ? (propertyMap[label] as IconDefinition)
    : faPrescription
}
